import { useEffect, useState } from 'react';
import { getHeaderScreenDetails } from '../getHeaderScreenDetails';
import { useConfigContext } from '../../shared/context/ConfigContext';

export default function useScreensDropdownOptions(screenGridId: number) {
  const [screenOptions, setScreenOptions] = useState([]);
  const { configSchema } = useConfigContext();

  useEffect(() => {
    const fetchScreens = async () => {
      const screensDetails = await getHeaderScreenDetails(screenGridId, configSchema);
      const screenList = screensDetails[`${configSchema}_mbd_screens`].map(
        ({ id: value, screen_display_name_en: label }) => ({ value, label }),
      );
      setScreenOptions(screenList);
    };
    fetchScreens();
  }, []);

  return { screenOptions };
}
